import axios from 'axios';
import {
  BASE_URL,
  URL_CATEGORIES,
  URL_CATEGORY,
  URL_CATEGORY_ITEMS,
  URL_CATEGORY_PARAM, URL_CONSTRUCT_LOAD, URL_CONSTRUCT_SAVE_AS,
  URL_PRODUCT_GET, URL_PRODUCT_IN_CONSTRUCT
} from '../utils/Constant';

export function findAll(withProducts) {
  return axios
    .get(BASE_URL + URL_CATEGORIES, {params: {withProducts}})
    .then((r) => r.data);
}

export function findAllItemByCategoryId(id) {
  return axios
    .get(BASE_URL + URL_CATEGORY_ITEMS, {params: {id}})
    .then((r) => r.data);
}

export function findBySlug(slug) {
  return axios
    .get(BASE_URL + URL_CATEGORY, {params: {slug}})
    .then((r) => r.data);
}

export function getParamBySlug(slug, param) {
  return axios
    .get(BASE_URL + URL_CATEGORY_PARAM, {params: {slug, param}})
    .then((r) => r.data);
}

export function getItemBySlug(slug) {
  return axios
    .get(BASE_URL + URL_PRODUCT_GET, {params: {slug}})
    .then((r) => r.data);
}

export function getItemAttributeInConstructor(id) {
  return axios
    .get( URL_PRODUCT_IN_CONSTRUCT, {params: {id}})
    .then((r) => r.data);
}

export function constructSaveAs(type, data) {
  return axios
    .post(BASE_URL + URL_CONSTRUCT_SAVE_AS, {
      type, data
    })
    .then((r) => r.data);
}

export function loadPlaygroundFromDb(hash) {
  return axios
    .get(BASE_URL + URL_CONSTRUCT_LOAD, {params:{hash}})
    .then((r) => r.data);
}


/*
export function searchEvents(filters) {
  filters = filters || store.getState().filters.processed;
  return axios
    .post(URL_BASE + URL_EVENT_GET_ALL, filters)
    .then((r) => r.data);
}
*/
